import type { AccountSetupDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { accountSetup } from '@/features/auth/api/auth.api';
import { updateUser } from '@/stores/auth.store';

export function useAccountSetup() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: AccountSetupDto) => accountSetup(data),
    onSuccess: (response) => {
      updateUser(response.user);
      toast.success('Account setup complete!');
      navigate({ to: '/' });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Account setup failed. Please try again.');
    },
  });
}
